import { useMutation } from '@tanstack/react-query'
import { ExtendableMutationOptions } from 'shared/api/api.types'

import { forgeApi } from '../..'
import { AiReviewResult } from '../../forgeApi.types'

interface AiReviewResponse {
  ai_review: AiReviewResult
}

// On-demand advisory security review ("Let AI review it"). Runs a static scan +
// an isolated LLM over the widget HTML and returns findings; does NOT change the
// review decision.
const aiReviewArtifact = async (publicId: string): Promise<AiReviewResult> => {
  const response = await forgeApi.post<AiReviewResponse>(
    `/api/v1/artifacts/${encodeURIComponent(publicId)}/ai-review`,
    {}
  )
  return response.data.ai_review
}

export const useAiReviewArtifactMutation = (
  options?: ExtendableMutationOptions<AiReviewResult, string>
) =>
  useMutation({
    mutationFn: aiReviewArtifact,
    ...options
  })
